import { useQuery } from '@tanstack/react-query';
import useAcquireToken from '../../AuthToken/Hooks/useAcquireToken';
import useBSTInsightsAPI from '../../../apiclients/api/bstinsightsapi';
import { GRID_DATA_QUERY_PREFIX } from './utils/constants';

export const getInvitableUsersQueryKey = [GRID_DATA_QUERY_PREFIX, "getInvitableUsers"]

export const useGetInvitableUsers = () => {
  const { getInvitableUsers } = useBSTInsightsAPI();
  const { getTokenSilently } = useAcquireToken();
  return useQuery({
    queryKey: getInvitableUsersQueryKey,
    queryFn: async () => {
      const token = await getTokenSilently();
      if (!token) return [];
      return await getInvitableUsers(token);
    },
  });
}